import { createContext } from 'react'

const notaContext = createContext();

export default notaContext;